import { TemplateParamsPlugin } from "/home/snaumann/Development/public_html/ludwig-pfeiffer/site/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.155.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_59519b6957fd58652f5c8fa3b2c149b0/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  plugins: [TemplateParamsPlugin],
}